import React, {useCallback, useRef, useState} from 'react';
import {Table, Button, Card, DatePicker, message, Form, Row, Col, Space, InputNumber, Select} from 'antd';
import {DownloadOutlined, FileExcelFilled, FileTextOutlined, SearchOutlined} from '@ant-design/icons';
import SelectVehicle from './SelectVehicle';
import {useNewFmsLogReportFullMutation} from '../../../slices/rootApiSlices/reportApiSlice';
import {useSelector} from 'react-redux';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import {exportToExcel} from "../../../components/exportToExcel";
import moment from "moment";

const CanBus = () => {

    const {Option} = Select;

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 30,
        total: 0,
    });

    const {RangePicker} = DatePicker;
    const [endDate, setEndDate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [infoData, setInfoData] = useState();
    const [vehicle_id, setVehicleID] = useState('');
    const [selectedOperator, setSelectedOperator] = useState('');
    const searchInput = useRef(null);
    const {user} = useSelector((state) => state.auth);
    const [fmsLogFullHandle, {isLoading}, error] = useNewFmsLogReportFullMutation();

    function disabledDate(current) {
        const tomorrow = moment().add(1, 'days').startOf('day');
        return current && current >= tomorrow;
    }

    const selectedColumns = [
        'currentGear',
        'brakePedalPosition',
        'actualRetarderPercentTorque',
        'fuelRate',
        'wheelBasedSpeed',
        'mcuid',
        'vehicleSpeed',
        'engineSpeed',
        'createdAt',
        'actualEnginePercentTorque',
        'vm',
        'drv1',
        'drv2',
        'instantaneousFuelEconomy',
        'pbs',
        'acceleratorPedalPosition',
        'pdoors',
        'bellowPressFrontAxleLeft',
        'bellowPressFrontAxleRight',
        'bellowPressRearAxleLeft',
        'bellowPressRearAxleRight',
        'steeringWheelAngle',
        'fuelLevel',
        'engineTotalHoursOfOperation',
        'highResVehicleTotalDistance',
        'engineCoolantTemp',
        'ambientAirTemp',
        'serviceBrakeAirPressureCircuit1',
        'serviceBrakeAirPressureCircuit2',
        'LiquetEngineTotalFuelUsed',
        'AftertreatmentDieselExhaustFluidTank1Level',
        'alt1',
        'alt2',
        'alt3',
        'acc',
        'GaseousTotalFuelUsed',
        'driver1Id',
        'driver2Id',
        'hybridBatteryPackRemainingCharge',
        'vehicle_id',
        'vehicleId',
        'engineDM1',
        'transmissionDM1',
        'absDM1',
        'klima',
        'uzun-far',
        'kisa-far',
        'donus-sinyalleri',
        'tehlike-uyarisi',
        'engelliler-icin-anlam',
        'el-freni',
        'fren-arizasi',
        'tavan-kapagi',
        'yakit-seviyesi',
        'motor-suyu-sogutma',
        'akilli-sarj-durumu',
        'motor-yagi',
        'pozisyon-lambalari',
        'on-sis-lambalari',
        'arka-sis-lambalari',
        'park-isitma',
        'motor-mi-gostergesi',
        'servis-ve-bakim',
        'sanziman-sivisi',
        'sanziman-hatasi',
        'abs-arizasi',
        'asinmis-fren-arizasi',
        'on-cam-yikama-sivisi',
        'lastik-arizasi',
        'ariza-genel-ariza',
        'motor-yagi-sicaklik-gostergesi',
        'motor-yagi-seviyesi',
        'motor-sogutma-suyu',
        'direksiyon-sivisi-seviyesi',
        'direksiyon-arizasi',
        'yukseklik-kontrolu',
        'retarder',
        'motor-emisyon-sistemi',
        'esc-gostergesi',
        'fren-lambasi',
        'koruklu-arac',
        'durma-talebi',
        'cocuk-arabasi-istegi',
        'otobus-duragi-freni',
        'adblue-seviyesi',
        'yükseltme',
        'indirme',
        'düşürme',
        'motor-Bloğu-sıcaklık',
        'yardımcı-hava-basıncı',
        'hava-filtresi',
        'yakıt-filtresi-fark-basıncı',
        'emniyet-kemeri',
        'ebs',
        'şeritten-ayrılma-göstergesi',
        'gelişmiş-acil-durum-fren-sistemi',
        'römork-bağlanı',
        'abs-trailer',
        'airbag',
        'ebs-trailer',
        'takograf-göstergesi',
        'esc-gostergesi-kapalı',
        'şeritten-ayrilma-göstergesi-kapalı',
        'motor-emisyon-filtresi',
        'elektirik-motoru-Arızaları',
        'adblue-sıcaklığı',
        'multiplex-sistem',
        'fms-standardı-için-ayrılmıştır',
        'date',
        'plateNumber',
        'chassisNumber',
        'operationNumber',
        "ain",
        'd1_os',
        'd1_es',
        'd2_os',
        'd2_es',
        'd3_os',
        'd3_es',
        'd4_os',
        'd4_es',
        'd5_os',
        'gps'
    ];

    const selectedSearchCol = [
        'currentGear',
        'brakePedalPosition',
        'actualRetarderPercentTorque',
        'fuelRate',
        'wheelBasedSpeed',
        'mcuid',
        'vehicleSpeed',
        'engineSpeed',
        'createdAt',
        'actualEnginePercentTorque',
        'vm',
        'drv1',
        'drv2',
        'instantaneousFuelEconomy',
        'pbs',
        'acceleratorPedalPosition',
        'pdoors',
        'bellowPressFrontAxleLeft',
        'bellowPressFrontAxleRight',
        'bellowPressRearAxleLeft',
        'bellowPressRearAxleRight',
        'steeringWheelAngle',
        'fuelLevel',
        'engineTotalHoursOfOperation',
        'highResVehicleTotalDistance',
        'engineCoolantTemp',
        'ambientAirTemp',
        'serviceBrakeAirPressureCircuit1',
        'serviceBrakeAirPressureCircuit2',
        'LiquetEngineTotalFuelUsed',
        'AftertreatmentDieselExhaustFluidTank1Level',
        'alt1',
        'alt2',
        'alt3',
        'GaseousTotalFuelUsed',
        'driver1Id',
        'driver2Id',
        'hybridBatteryPackRemainingCharge',
        'vehicle_id',
        'vehicleId',
        'engineDM1',
        'transmissionDM1',
        'absDM1',
        'klima',
        'uzun-far',
        'kisa-far',
        'donus-sinyalleri',
        'tehlike-uyarisi',
        'engelliler-icin-anlam',
        'el-freni',
        'fren-arizasi',
        'tavan-kapagi',
        'yakit-seviyesi',
        'motor-suyu-sogutma',
        'akilli-sarj-durumu',
        'motor-yagi',
        'pozisyon-lambalari',
        'on-sis-lambalari',
        'arka-sis-lambalari',
        'park-isitma',
        'motor-mi-gostergesi',
        'servis-ve-bakim',
        'sanziman-sivisi',
        'sanziman-hatasi',
        'abs-arizasi',
        'asinmis-fren-arizasi',
        'on-cam-yikama-sivisi',
        'lastik-arizasi',
        'ariza-genel-ariza',
        'motor-yagi-sicaklik-gostergesi',
        'motor-yagi-seviyesi',
        'motor-sogutma-suyu',
        'direksiyon-sivisi-seviyesi',
        'direksiyon-arizasi',
        'yukseklik-kontrolu',
        'retarder',
        'motor-emisyon-sistemi',
        'esc-gostergesi',
        'fren-lambasi',
        'koruklu-arac',
        'durma-talebi',
        'cocuk-arabasi-istegi',
        'otobus-duragi-freni',
        'adblue-seviyesi',
        'yükseltme',
        'indirme',
        'düşürme',
        'motor-Bloğu-sıcaklık',
        'yardımcı-hava-basıncı',
        'hava-filtresi',
        'yakıt-filtresi-fark-basıncı',
        'emniyet-kemeri',
        'ebs',
        'şeritten-ayrılma-göstergesi',
        'gelişmiş-acil-durum-fren-sistemi',
        'römork-bağlanı',
        'abs-trailer',
        'airbag',
        'ebs-trailer',
        'takograf-göstergesi',
        'esc-gostergesi-kapalı',
        'şeritten-ayrilma-göstergesi-kapalı',
        'motor-emisyon-filtresi',
        'elektirik-motoru-Arızaları',
        'adblue-sıcaklığı',
        'multiplex-sistem',
        'fms-standardı-için-ayrılmıştır',
        'date',
        'plateNumber',
        'chassisNumber',
        'operationNumber',
        'd1_os',
        'd1_es',
        'd2_os',
        'd2_es',
        'd3_os',
        'd3_es',
        "ain",
        'd4_os',
        'd4_es',
        'd5_os',
    ];

    const handleReset = (clearFilters) => {
        clearFilters();
        setSelectedOperator('');
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters, close}) => (
            <div style={{padding: 8}}>
                <div style={{marginBottom: 8, display: 'flex'}}>
                    <InputNumber
                        style={{width: '49%', marginRight: 5}}
                        placeholder="Değer"
                        value={selectedKeys[0]}
                        onChange={(value) => setSelectedKeys(value ? [value] : [])}
                    />
                    <Select
                        style={{width: '49%'}}
                        onChange={(value) => setSelectedOperator(value)}
                        placeholder="Lütfen seçin"
                        value={selectedOperator}
                    >
                        <Option value=">">Büyüktür</Option>
                        <Option value="<">Küçüktür</Option>
                        <Option value="=">Eşittir</Option>
                    </Select>
                </div>
                <Space>
                    <Button onClick={() => clearFilters && handleReset(clearFilters)} size="small" style={{width: 90}}>
                        Değeri Sil
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            });
                            setPagination({...pagination, current: 1});
                        }}
                    >
                        Filtrele
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        Kapat
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) => {
            const dataIndexValue = parseFloat(record[dataIndex]);
            const filterValue = parseFloat(value);
            if (isNaN(dataIndexValue) || isNaN(filterValue)) {
                return false;
            }
            switch (selectedOperator) {
                case '>':
                    return dataIndexValue > filterValue;
                case '<':
                    return dataIndexValue < filterValue;
                case '=':
                    return dataIndexValue === filterValue;
                default:
                    return false;
            }
        },
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) => text,
    });

    const options = [
        {
            label: 'Olusturulma Zamanı',
            value: 'createdAt',
            dataIndex: 'createdAt',
            key: 'createdAt',
            fixed: 'right',
            width: 100,
            sorter: (a, b) => {
                return new Date(a.createdAt) - new Date(b.createdAt);
            },
            render: (text) => {
                const date = new Date(text);
                date.setHours(date.getHours() + 3);
                const adjustedDate = date.toISOString().slice(0, 19).replace('T', ' ');
                return <span>{adjustedDate}</span>;
            },
        },
        {
            label: 'Konum',
            value: 'gps',
            dataIndex: 'gps',
            key: 'gps',
            width: '100%',
            fixed: 'left',
            render: (gps) => (
                <span>
                    {gps !== null && gps !== undefined && gps.lat && gps.lon ?
                        `Enlem: ${gps.lat}, Boylam: ${gps.lon}` : '-'}
                </span>
            )
        },
        {
            label: 'Retarder Torku (%)',
            value: 'actualRetarderPercentTorque',
            dataIndex: 'actualRetarderPercentTorque',
            key: 'actualRetarderPercentTorque',
            width: '100%',
            fixed: 'left',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Motor Hizi [RPM]',
            value: 'engineSpeed',
            dataIndex: 'engineSpeed.mean',
            key: 'engineSpeed.mean',
            sorter: (a, b) => a.engineSpeed.mean - b.engineSpeed.mean,
            render: (text, record) => (
                <span>{(record.engineSpeed && record.engineSpeed?.mean) || record.engineSpeed?.mean === 0 ? record.engineSpeed?.mean.toFixed(0) : '-'}</span>
            ),
        },
        {
            label: 'Akü Voltajı',
            value: 'ain',
            dataIndex: 'ain.ana5',
            key: 'ain.ana5',
            sorter: (a, b) => a.ain.ana5 - b.ain.ana5,
            render: (text, record) => (
                <span>{(record.ain && record.ain?.ana5) || record.ain?.ana5 === 0 ? record.ain?.ana5.toFixed(2) : '-'}</span>
            ),
        },
        {
            label: 'İvme',
            value: 'acc',
            dataIndex: 'acc',
            key: 'acc',
            render: (text, record) => {
                const axisX = record.acc?.axisX?.mean !== undefined ? record.acc.axisX.mean.toFixed(2) : '-';
                const axisY = record.acc?.axisY?.mean !== undefined ? record.acc.axisY.mean.toFixed(2) : '-';
                const axisZ = record.acc?.axisZ?.mean !== undefined ? record.acc.axisZ.mean.toFixed(2) : '-';
                return (
                    <span>
                        X: {axisX} | Y: {axisY} | Z: {axisZ}
                    </span>
                );
            },
        },
        {
            label: 'Arac Hizi [km/h]',
            value: 'vehicleSpeed',
            dataIndex: 'vehicleSpeed',
            key: 'vehicleSpeed',
            fixed: 'left',
            sorter: (a, b) => a.vehicleSpeed.mean - b.vehicleSpeed.mean,
            render: (text, record) => (
                <span>{(record.vehicleSpeed && record.vehicleSpeed?.mean) || record.vehicleSpeed?.mean === 0 ? record.vehicleSpeed?.mean.toFixed(0) : '-'}</span>
            ),
        },
        {
            label: 'Anlik Yakit Tüketimi [L/100km]',
            value: 'fuelRate',
            dataIndex: 'fuelRate',
            key: 'fuelRate',
            sorter: (a, b) => a.fuelRate - b.fuelRate,
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Tekerlek Bazli Hiz [km/h]',
            value: 'wheelBasedSpeed',
            dataIndex: 'wheelBasedSpeed.mean', // Adjusted for mean value
            key: 'wheelBasedSpeed.mean',
            sorter: (a, b) => a.wheelBasedSpeed.mean - b.wheelBasedSpeed.mean,
            render: (text, record) => (
                <span>{(record.wheelBasedSpeed && record.wheelBasedSpeed?.mean) || record.wheelBasedSpeed?.mean === 0 ? record.wheelBasedSpeed?.mean.toFixed(0) : '-'}</span>
            ),
        },
        {
            label: 'Gaz Pedali Pozisyonu (%)',
            value: 'acceleratorPedalPosition',
            dataIndex: 'acceleratorPedalPosition',
            key: 'acceleratorPedalPosition',
            sorter: (a, b) => a.acceleratorPedalPosition - b.acceleratorPedalPosition,
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Vites',
            value: 'currentGear',
            dataIndex: 'currentGear',
            key: 'currentGear',
            sorter: (a, b) => a.currentGear - b.currentGear,
            render: (text) => (
                <span>{text === -1 ? 'R' : (text !== null && text !== undefined && text !== '' ? text : '-')}</span>
            )
        },
        {
            label: 'Sol Ön Aks (kPa)',
            value: 'bellowPressFrontAxleLeft',
            dataIndex: 'bellowPressFrontAxleLeft',
            key: 'bellowPressFrontAxleLeft',
            sorter: (a, b) => a.bellowPressFrontAxleLeft - b.bellowPressFrontAxleLeft,
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Sag Ön Aks (kPa)',
            value: 'bellowPressFrontAxleRight',
            dataIndex: 'bellowPressFrontAxleRight',
            key: 'bellowPressFrontAxleRight',
            sorter: (a, b) => a.bellowPressFrontAxleRight - b.bellowPressFrontAxleRight,
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Kapı 1 Durumu',
            value: 'd1_os',
            dataIndex: 'd1_os',
            key: 'd1_os',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'OPENED':
                        return 'Açık';
                    case 'CLOSED':
                        return 'Kapalı';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Kapı 1 Hata Durumu',
            value: 'd1_es',
            dataIndex: 'd1_es',
            key: 'd1_es',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'ENABLED':
                        return 'Uygun';
                    case 'DISABLED':
                        return 'Uygun değil';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Kapı 2 Durumu',
            value: 'd2_os',
            dataIndex: 'd2_os',
            key: 'd2_os',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'OPENED':
                        return 'Açık';
                    case 'CLOSED':
                        return 'Kapalı';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Kapı 2 Hata Durumu',
            value: 'd2_es',
            dataIndex: 'd2_es',
            key: 'd2_es',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'ENABLED':
                        return 'Uygun';
                    case 'DISABLED':
                        return 'Uygun değil';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Kapı 3 Hata Durumu',
            value: 'd3_es',
            dataIndex: 'd3_es',
            key: 'd3_es',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'ENABLED':
                        return 'Uygun';
                    case 'DISABLED':
                        return 'Uygun değil';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Kapı 3 Durumu',
            value: 'd3_os',
            dataIndex: 'd3_os',
            key: 'd3_os',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'OPENED':
                        return 'Açık';
                    case 'CLOSED':
                        return 'Kapalı';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Kapı 4  Durumu',
            value: 'd4_os',
            dataIndex: 'd4_os',
            key: 'd4_os',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'OPENED':
                        return 'Açık';
                    case 'CLOSED':
                        return 'Kapalı';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Kapı 4 Hata Durumu',
            value: 'd4_es',
            dataIndex: 'd4_es',
            key: 'd4_es',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'ENABLED':
                        return 'Uygun';
                    case 'DISABLED':
                        return 'Uygun değil';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Sürücü Adı',
            value: 'driverName',
            dataIndex: 'driverName',
            key: 'driverName',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Sürücü Soyadı',
            value: 'driverSurname',
            dataIndex: 'driverSurname',
            key: 'driverSurname',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Sol Arka Aks (kPa)',
            value: 'bellowPressRearAxleLeft',
            dataIndex: 'bellowPressRearAxleLeft',
            key: 'bellowPressRearAxleLeft',
            sorter: (a, b) => a.bellowPressRearAxleLeft - b.bellowPressRearAxleLeft,
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Sag Arka Aks (kPa)',
            value: 'bellowPressRearAxleRight',
            dataIndex: 'bellowPressRearAxleRight',
            key: 'bellowPressRearAxleRight',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Aktüel Motor Torku (%)',
            value: 'actualEnginePercentTorque',
            dataIndex: 'actualEnginePercentTorque',
            key: 'actualEnginePercentTorque',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Araç Hareketi',
            value: 'vm',
            dataIndex: 'vm',
            key: 'vm',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'VM_NOT_DETECTED':
                        return 'Algılanmadı';
                    case 'VM_DETECTED':
                        return 'Algılandı';
                    case 'VM_ERROR':
                        return 'Hata';
                    case 'VM_NOT_AVAILABLE':
                        return 'Mevcut Değil';
                    default:
                        return text;
                }
            },
        },
        {
            label: 'Sürücü 1 Çalışma Durumu',
            value: 'drv1',
            dataIndex: 'drv1',
            key: 'drv1',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'REST':
                        return 'Dinleme';
                    case 'DRIVE':
                        return 'Sürüşte';
                    case 'DRV_NOT_AVAILABLE':
                        return 'Uygun değil';
                    default:
                        return text;
                }
            },
        },
        {
            label: 'Sürücü 2 Çalışma Durumu',
            value: 'drv2',
            dataIndex: 'drv2',
            key: 'drv2',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'REST':
                        return 'Dinleme';
                    case 'DRIVE':
                        return 'Sürüşte';
                    case 'DRV_NOT_AVAILABLE':
                        return 'Uygun değil';
                    default:
                        return text;
                }
            },
        },
        {
            label: 'Mevcut Araç Hızında Mevcut Yakıt Ekonomisi',
            value: 'instantaneousFuelEconomy',
            dataIndex: 'instantaneousFuelEconomy',
            key: 'instantaneousFuelEconomy',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'El Freni Durumu',
            value: 'pbs',
            dataIndex: 'pbs',
            key: 'pbs',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'SET':
                        return 'Ayarlandı';
                    case 'NOT_SET':
                        return 'Ayarlanmadı';
                    case 'PB_NOT_AVAILABLE':
                        return 'PB Uygun değil';
                    default:
                        return text;
                }
            },
        },
        {
            label: 'Tüm Kapıların ortak pozisyonu',
            value: 'pdoors',
            dataIndex: 'pdoors',
            key: 'pdoors',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'PD_NOT_AVAILABLE':
                        return 'Uygun değil';
                    case 'AT_LEAST_ONE_DOOR_IS_OPEN':
                        return 'En az bir kapı açık';
                    case 'ALL_DOOR_CLOSED':
                        return 'Tüm kapılar kapalı';
                    case 'CLOSING_LAST_DOOR':
                        return 'Son kapı kapanıyor';
                    default:
                        return text;
                }
            },
        },
        {
            label: 'Fren Pedal Pozisyonu (%)',
            value: 'brakePedalPosition',
            dataIndex: 'brakePedalPosition',
            key: 'brakePedalPosition',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Direksiyon Açısı',
            value: 'steeringWheelAngle',
            dataIndex: 'steeringWheelAngle',
            key: 'steeringWheelAngle',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Ortam Hava Sıcaklığı (C°)',
            value: 'ambientAirTemp',
            dataIndex: 'ambientAirTemp',
            key: 'ambientAirTemp',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: '1. Alternatör Şarj Durumu',
            value: 'alt1',
            dataIndex: 'alt1',
            key: 'alt1',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'NOT_CHARGING':
                        return 'Şarj Olmuyor';
                    case 'CHARGING':
                        return 'Şarj Durumunda';
                    default:
                        return text;
                }
            },
        },
        {
            label: '2. Alternatör Şarj Durumu',
            value: 'alt2',
            dataIndex: 'alt2',
            key: 'alt2',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'NOT_CHARGING':
                        return 'Şarj Olmuyor';
                    case 'CHARGING':
                        return 'Şarj Durumunda';
                    default:
                        return text;
                }
            },
        },
        {
            label: '3. Alternatör Şarj Durumu',
            value: 'alt3',
            dataIndex: 'alt3',
            key: 'alt3',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'NOT_CHARGING':
                        return 'Şarj Olmuyor';
                    case 'CHARGING':
                        return 'Şarj Durumunda';
                    default:
                        return text;
                }
            },
        },
        {
            label: 'Toplam Gazlı Yakıt Tüketimi (kg)',
            value: 'GaseousTotalFuelUsed',
            dataIndex: 'GaseousTotalFuelUsed',
            key: 'GaseousTotalFuelUsed',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Sürücü 1 kimliği',
            value: 'driver1Id',
            dataIndex: 'driver1Id',
            key: 'driver1Id',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Sürücü 2 kimliği',
            value: 'driver2Id',
            dataIndex: 'driver2Id',
            key: 'driver2Id',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Hibrit Pil Paketinin Kalan Şarj Yüzdesi',
            value: 'hybridBatteryPackRemainingCharge',
            dataIndex: 'hybridBatteryPackRemainingCharge',
            key: 'hybridBatteryPackRemainingCharge',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Yakit Seviyesi (%)',
            value: 'fuelLevel',
            dataIndex: 'fuelLevel',
            key: 'fuelLevel',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Motor Toplam Çalisma Saati',
            value: 'engineTotalHoursOfOperation',
            dataIndex: 'engineTotalHoursOfOperation',
            key: 'engineTotalHoursOfOperation',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Arac Toplam Mesafesi [km]',
            value: 'highResVehicleTotalDistance',
            dataIndex: 'highResVehicleTotalDistance',
            key: 'highResVehicleTotalDistance',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Motor Sogutma Sistemi Sivisi Sicakligi (C°)',
            value: 'engineCoolantTemp',
            dataIndex: 'engineCoolantTemp',
            key: 'engineCoolantTemp',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Servis Freni Hava Basinci Devresi 1 (kPa)',
            value: 'serviceBrakeAirPressureCircuit1',
            dataIndex: 'serviceBrakeAirPressureCircuit1',
            key: 'serviceBrakeAirPressureCircuit1',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Servis Freni Hava Basinci Devresi 2 (kPa)',
            value: 'serviceBrakeAirPressureCircuit2',
            dataIndex: 'serviceBrakeAirPressureCircuit2',
            key: 'serviceBrakeAirPressureCircuit2',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Sivi Motor Toplam Yakit Kullanimi [L]',
            value: 'LiquetEngineTotalFuelUsed',
            dataIndex: 'LiquetEngineTotalFuelUsed',
            key: 'LiquetEngineTotalFuelUsed',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Adblue Seviyesi (%)',
            value: 'AftertreatmentDieselExhaustFluidTank1Level',
            dataIndex: 'AftertreatmentDieselExhaustFluidTank1Level',
            key: 'AftertreatmentDieselExhaustFluidTank1Level',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '-' ? text : '-'}</span>
            )
        },
        {
            label: 'Araç Durumu',
            value: 'mcuid',
            dataIndex: 'mcuid.uidw1',
            key: 'mcuid.uidw1',
            render: (text, record) => {
                let uidw1 = record.mcuid?.uidw1;
                let pbs = record.pbs;
                let durum;

                if (uidw1 === "11") {
                    durum = pbs === 'SET' ? 'Rölanti' : 'Seyir Halinde';
                } else if (uidw1 === "01") {
                    durum = 'Durma';
                } else if (uidw1 === "00" || uidw1 === "10") {
                    durum = 'Park';
                } else {
                    durum = ' ';
                }
                return <span>{durum}</span>;
            },
        }
    ];

    function handleDateChange(date, dateString) {
        const adjustDate = (dateStr) => {
            const date = new Date(dateStr.replace(' ', 'T') + '.000Z');
            date.setHours(date.getHours() - 3); // Subtract 3 hours
            return date.toISOString().slice(0, 19).replace('T', ' ');
        };

        const startDate = adjustDate(dateString[0]);
        const endDate = adjustDate(dateString[1]);

        setStartDate(startDate);
        setEndDate(endDate);
    }

    const columns = options
        .filter((option) => selectedColumns.includes(option.value))
        .map((option) => ({
            title: option.label,
            dataIndex: option.dataIndex,
            key: option.key,
            sorter: option.sorter ? option.sorter : undefined,
            ...(selectedSearchCol.includes(option.value) && {
                ...getColumnSearchProps(option.dataIndex),
            }),
            render: option.render ? option.render : (text) => text,
        }));


    const handleQuery = useCallback(async () => {
        try {
            const res = await fmsLogFullHandle({
                id: vehicle_id,
                token: user?.token,
                startDate,
                endDate,
            }).unwrap();
            const infoData = {
                plateNumber: res?.vehicleInfo?.plateNumber || '',
                operationNumber: res?.vehicleInfo?.operationNumber || '',
                chassisNumber: res?.vehicleInfo?.chassisNumber || '',
                start_date: startDate,
                end_date: endDate,
                lineNumber: 'Tanımlanmadı'
            };
            setTableData(res);
            setInfoData(infoData);
            setPagination({...pagination, total: res?.pagination?.total});
            message.success(res?.message || 'İşlem başarılı..');
        } catch (e) {
            message.error(e?.data?.messageTR || 'Bir hata oluştu. Lütfen bir süre sonra tekrar deneyiniz.');
        }
    }, [fmsLogFullHandle, startDate, endDate, pagination, user?.token, vehicle_id]);

    const onPageChange = (page, pageSize) => {
        setPagination({current: page, pageSize: pageSize});
    };

    const handleExportExcel = () => {
        const exportData = tableData?.data.map((row) => {
            const formattedRow = {};

            options.forEach((option) => {
                const {dataIndex, render, label} = option;
                const value = row[dataIndex];
                if (render) {
                    const renderedValue = render(value, row);
                    formattedRow[label] = React.isValidElement(renderedValue)
                        ? renderedValue.props.children
                        : renderedValue;
                } else {
                    formattedRow[label] = value;
                }
            });

            return formattedRow;
        });

        exportToExcel(exportData, options, infoData, 'Can_Bus_Raporu', user?.name);
    };

    const generatePDF = () => {

        const pageSize = 'a0';
        const orientation = 'landscape';

        const doc = new jsPDF({
            format: pageSize,
            orientation: orientation,
        });

        // En üstteki bilgileri ekleme
        const kapıNumarası = infoData?.operationNumber ? infoData?.operationNumber : '-';
        const araçPlakası = infoData?.plateNumber ? infoData?.plateNumber : '-';
        const raporTarihAralıkları = startDate && endDate
            ? `${moment(startDate).add(3, 'hours').format('DD/MM/YYYY HH:mm:ss')} - ${moment(endDate).add(3, 'hours').format('DD/MM/YYYY HH:mm:ss')}`
            : '-';
        const sürücüAdıSoyadı = infoData?.driverName ? `${infoData?.driverName} ${infoData?.driverSurname}` : 'Tanimlanmadi';
        const raporOluşturulmaTarihi = moment().format('DD.MM.YYYY HH:mm');
        const raporuOluşturan = user ? user?.name : '-';

        doc.setFontSize(12);

        doc.text(`Kapi Numarasi: ${kapıNumarası}`, 15, 10);
        doc.text(`Rapor Tarih Araliklari: ${raporTarihAralıkları}`, 120, 10);
        doc.text(`Arac Plakasi: ${araçPlakası}`, 15, 20);
        doc.text(`Surucu Adi / Soyadi: ${sürücüAdıSoyadı}`, 120, 20);
        doc.text(`Rapor Olusturulma Tarihi: ${raporOluşturulmaTarihi}`, 15, 30);
        doc.text(`Raporu Olusturan: ${raporuOluşturan}`, 120, 30);

        const columnsForPDF = selectedColumns.map((column) => {
            const option = options.find((option) => option.value === column);
            return option ? option.label : '';
        });

        const tableDataForPDF = tableData && tableData?.data.map((item) => {
            return selectedColumns.map((column) => {
                if (column === 'date') {
                    const text = item[column];
                    if (!text || text === "-") {
                        return "Tarih yok";
                    }
                    const [day, month, yearAndTime] = text.split('.');
                    const [year, time] = yearAndTime.split(' ');
                    const isoDateString = `${year}-${month}-${day}T${time}`;
                    const date = new Date(isoDateString);
                    if (isNaN(date)) {
                        return "Geçersiz Tarih";
                    }
                    date.setHours(date.getHours() + 6);
                    return date.toISOString().slice(0, 19).replace('T', ' ');
                }

                const value = item[column];
                if (value === null || value === undefined || isNaN(value)) {
                    return "0";
                }
                return parseFloat(value).toFixed();
            });
        });

        doc.autoTable({
            head: [columnsForPDF],
            body: tableDataForPDF,
            startY: 40,
        });

        doc.save('Can_Bus_Raporu.pdf');
    };

    return (
        <Row justify="center">
            <Col xs={24} sm={24} md={24} lg={24} xl={16} xxl={12}>
                <Card title="Canbus Raporu" type="inner" size="small" style={{marginBottom: 10}}>
                    <Form>
                        <SelectVehicle name="vehicleID" onChange={(e) => setVehicleID(e)}/>
                        <Form.Item name="byDate" label="Tarih Aralığı">
                            <RangePicker
                                showTime
                                disabledDate={disabledDate}
                                disabled={isLoading}
                                placeholder={['Başlangıç Tarihi', 'Bitiş Tarihi']}
                                style={{margin: 'auto', marginRight: 3, width: '100%'}}
                                onChange={handleDateChange}
                            />
                        </Form.Item>
                    </Form>
                    <Button
                        type="primary"
                        onClick={handleQuery}
                        style={{marginTop: '16px'}}
                        icon={<DownloadOutlined/>}
                        loading={isLoading}
                        disabled={!vehicle_id || !startDate || !endDate}
                    >
                        Rapor Oluştur
                    </Button>
                </Card>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={20} xxl={24}>
                <Card
                    type="inner"
                    title="Sonuçlar"
                    size="small"
                    extra={
                        <>
                            <Button
                                style={{marginRight: 5}}
                                size="small"
                                type="primary"
                                onClick={handleExportExcel}
                                icon={<FileTextOutlined/>}
                                disabled={isLoading || !tableData?.data || tableData?.data.length === 0}
                            >
                                Excel
                            </Button>
                            <Button
                                type="primary"
                                size="small"
                                onClick={generatePDF}
                                icon={<FileExcelFilled/>}
                                disabled={true}
                            >
                                PDF
                            </Button>
                        </>
                    }
                >
                    {tableData?.data && tableData?.data.length > 0 && columns.length > 0 && (
                        <Table
                            rowKey="id"
                            loading={isLoading}
                            bordered={true}
                            size="small"
                            columns={columns}
                            scroll={{x: 'scroll'}}
                            dataSource={tableData?.data}
                            pagination={{
                                current: pagination.current,
                                pageSize: pagination.pageSize,
                                total: pagination.total,
                                onChange: onPageChange,
                            }}
                            error={error}
                        />
                    )}
                </Card>
            </Col>
        </Row>
    );
};

export default CanBus;
